const aiHub = {
  modeChat: "Чат",
  modeChatDesc: "Общий разговор с ассистентом",
  modeAnalyze: "Анализ",
  modeAnalyzeDesc: "Анализ данных проектов и оценок здоровья",
  modeWrite: "Написание",
  modeWriteDesc: "Черновики документов, писем и отчётов",
  modeDecompose: "Декомпозиция",
  modeDecomposeDesc: "Разбиение эпиков на истории и задачи",
  modeWork: "Менеджер задач",
  modeWorkDesc: "Менеджер GAM — знает что есть, что открыто, что делать",
  workConnected: "Подключено",
  workDisconnected: "Отключено",
  workSuggestStatus: "Какой статус проектов?",
  workSuggestNext: "Какая следующая задача?",
  workSuggestDecisions: "Какие последние решения?",
  workSuggestPriority: "Какой сейчас высший приоритет?",
  confidenceHigh: "Уверен",
  confidenceMedium: "Вероятно",
  confidenceLow: "Не уверен",
  actionConfirm: "Подтвердить",
  actionCancel: "Отменить",
  actionPreviewTitle: "Подтверждение действия",
  newChat: "Новый чат",
  conversations: "Разговоры",
  noConversations: "Нет разговоров",
  emptyChat: "Выберите режим и начните разговор",
  context: "Контекст",
  addContext: "Добавить контекст",
  sendMessage: "Отправить",
  typePlaceholder: "Введите сообщение...",
  charCount: "символов",
  suggestChatStatus: "Какой статус сегодня?",
  suggestChatSummarize: "Суммировать активные проекты",
  suggestAnalyzeHealth: "Анализ оценок здоровья",
  suggestAnalyzeAttention: "Что требует внимания?",
  suggestWriteReport: "Написать еженедельный отчёт",
  suggestWriteEmail: "Составить письмо клиенту",
  suggestDecomposeEpic: "Декомпозиция эпика в истории",
  suggestDecomposeTasks: "Создать задачи из фичи",
  thinking: "Думаю...",
  mockDisclaimer: "Демо-режим — примерные ответы",
  deleteConversation: "Удалить разговор",
  untitled: "Безымянный разговор",
  streaming: "Отвечаю...",
  stopGeneration: "Стоп",
  tokenUsage: "Дневное потребление токенов",
  tokenBudgetWarning: "80% дневного бюджета использовано",
  tokenBudgetExceeded: "Дневной бюджет исчерпан — попробуйте завтра",
  liveMode: "Онлайн",
  modelLabel: "Модель",
  conversationLimit: "Лимит 50 сообщений — начните новый чат",
  savingToCloud: "Сохранение...",
  savedToCloud: "Сохранено в облаке",
  offlineMode: "Офлайн-режим",
  toolbarBold: "Жирный",
  toolbarItalic: "Курсив",
  toolbarStrikethrough: "Зачёркнутый",
  toolbarCode: "Код",
  toolbarLink: "Ссылка",
  toolbarBulletList: "Список",
  toolbarNumberedList: "Нумерованный список",
  toolbarConvertLang: "Сменить язык",
  toolbarConvertTooltip: "Исправить раскладку",
  agentOrchestrator: "Оркестратор",
  agentPm: "PM Бот",
  agentDev: "Dev Бот",
  agentDesign: "Дизайн Бот",
  agentQa: "QA Бот",
  agentStrategy: "Стратег Бот",
  // AI Hub Pro — new keys
  knowledgeBase: "База знаний",
  knowledgeDescription: "Добавьте URL как знания для этого режима — AI будет ссылаться на их содержание в разговорах",
  addUrl: "Добавить",
  invalidUrl: "Неверный URL",
  urlLimit: "Максимум 5 URL на режим",
  urlDuplicate: "URL уже добавлен",
  urlFetchFailed: "Не удалось загрузить URL",
  searchConversations: "Поиск разговоров...",
  docPanel: "Документ",
  searchDocument: "Поиск документа...",
  noDocSelected: "Выберите документ для просмотра",
  attachImage: "Прикрепить изображение",
  dropImageHere: "Перетащите изображение сюда",
  replyTo: "Ответить",
  cancelReply: "Отменить ответ",
  mentionEntity: "Поиск сущности...",
  recentEntities: "Недавние",
  noEntitiesFound: "Сущности не найдены",
  copyMessage: "Копировать",
  regenerate: "Перегенерировать",
  // Action Preview
  actionExecuting: "Выполняется...",
  actionSuccess: "Готово",
  actionError: "Ошибка",
  actionRetry: "Повторить",
  actionNotionTask: "Задача Notion",
  // Personas
  personaSelector: "Советник",
  noPersona: "Без советника",
  selectPersona: "Выбрать советника",
  clearPersona: "Очистить",
  domainOperations: "Операции",
  domainFinance: "Финансы",
  domainLegal: "Юридический",
  domainHr: "HR",
  domainMarketing: "Маркетинг",
  domainTech: "Технологии",
  domainStrategy: "Стратегия",
  domainGeneral: "Общие",
} as const;
export default aiHub;
